<template>
  <div>
      <el-input class="search-el" size="mini" v-model="query.title" placeholder="请输入标题"></el-input>
      <el-button type="primary" size="mini" @click="getList()">
      查询
    </el-button>
    <el-button type="primary" size="small" @click="toCreate()">
      添加
    </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          label="标题"
          align="center"
          min-width="20%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.title }}</div>
            </el-button>
        </template> 
        </el-table-column>
        <el-table-column label="头像" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.avatar" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          align="center"
          min-width="10%"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          min-width="20%"
        ></el-table-column>

        <el-table-column
          label="排序"
          align="center"
          min-width="8%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateStudentStorySort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
        </template> 
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
              <el-button
              type="text"
              size="mini"
              @click="
                row.status == 1
                  ? updateStudentStoryStatus(row.id, 0)
                  : updateStudentStoryStatus(row.id, 1)
              "
            >
              <div>{{ row.status == 1 ? '下架' : '发布' }}</div>
            </el-button>

            <el-button
              type="danger"
              size="small"
              @click="deleteStudentStory(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { studentStoryList, updateStudentStoryStatus, deleteStudentStory, updateStudentStorySort } from "@/api/story";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        category: this.$route.query.category
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toCreate(id) {
      this.$router.push({
        path: "/story/studentStoryInfo",
        query: {
          id: id,
          category: this.$route.query.category
        }
      });
    },

    getList(str) {
      this.loading = true;
      studentStoryList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateStudentStorySort(id) {
        this.$prompt('请输入排序', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[0-9]/,
          inputErrorMessage: '格式不正确'
        }).then(({ value }) => {
          updateStudentStorySort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        }).catch(() => {
               
        });
    },

    updateStudentStoryStatus(id, status) {
      updateStudentStoryStatus({
            id: id,
            status: status,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
    },

    deleteStudentStory(id) {
    this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteStudentStory({
        id: id,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    });
  },
  },
  mounted() {
    
  },  
};
</script>